export const SITE_ORIGIN = 'https://verse.getverse.com';

export function getCanonicalUrl(pathname: string): string {
  // Canonicals identify a page, never a wallet address or other query state.
  const path = new URL(pathname, SITE_ORIGIN).pathname;
  return `${SITE_ORIGIN}${path}`;
}

export function getWalletAppOrigin(): string {
  // Both hosts must work during parallel testing. WalletConnect metadata
  // must describe the origin actually requesting the connection.
  return typeof window === 'undefined' ? SITE_ORIGIN : window.location.origin;
}
